import { createContext, useContext } from 'react';
import type { SessionConfig } from '@/hooks/useLearningSessionTracker';

export interface LearningSessionStatus {
  config: SessionConfig | null;
  currentSessionSeconds: number;
  todaySeconds: number;
  isTracking: boolean;
}

export interface LearningSessionContextValue {
  setMediaPlaying: (playing: boolean) => void;
  setActivityEngaged: (engaged: boolean) => void;
  markActivity: () => void;
  status: LearningSessionStatus;
}

export const LearningSessionContext = createContext<LearningSessionContextValue | null>(null);

export function useLearningSessionContext(): LearningSessionContextValue | null {
  return useContext(LearningSessionContext);
}

export function useLearningSessionStatus(): LearningSessionStatus | null {
  const ctx = useLearningSessionContext();
  return ctx?.status ?? null;
}
